import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { Option } from '@/common/types';
import { API_URL } from '@/dtos';

export const PLAN_TYPES_KEY = 'getAllPlanTypesList';

export interface PlanTypeResponse {
  id: number;
  type_code: string;
  description: string;
}

export const getPlanTypes = () => () => api.get(API_URL.ENUMS_ACCOUNT_TYPES);

export const usePlanTypesQuery = () => {
  const { data } = useQuery([PLAN_TYPES_KEY], getPlanTypes());

  const formatedPlanTypes = useMemo<Option[]>(() => {
    const list = data?.data || [];
    const exception = [
      // 'HSA',/
      'EXTERNAL',
      'CLEARING',
      'SUB_ACCOUNT',
      'OMNIBUS',
      // 'ADOPTION',
      // 'WELLNESS',
      // 'SPECIALTY',
      'WAGEPARITY',
      'NOTIONAL_PAYROLL',
      'PLAN_OMNIBUS',
      'NOTIONAL_FUNDING',
    ];
    const cutList = list.filter((item) => !exception.includes(item.type_code || ''));
    return cutList.map((item) => ({
      key: `${item.type_code}`,
      value: item.description,
      title: item.description,
    }));
  }, [data]);

  return formatedPlanTypes;
};

export default usePlanTypesQuery;
